"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var Layout_1 = require("./components/Layout");
var Home_1 = require("./components/Home");
var Rules_1 = require("./components/Rules");
var Timeline_1 = require("./components/Timeline");
var FetchData_1 = require("./components/FetchData");
var Organizers_1 = require("./components/Organizers");
var Links_1 = require("./components/Links");
var DnsMOS_1 = require("./components/DnsMOS");
require("./custom.css");
var FinalResults_1 = require("./components/FinalResults");
var Phase1Results_1 = require("./components/Phase1Results");
var Phase2Results_1 = require("./components/Phase2Results");
exports.default = (function () { return (React.createElement(Layout_1.default, null,
    React.createElement(react_router_1.Route, { exact: true, path: '/', component: Home_1.default }),
    React.createElement(react_router_1.Route, { exact: true, path: '/:challenge', component: Home_1.default }),
    React.createElement(react_router_1.Route, { path: '/rules/:challenge', component: Rules_1.default }),
    React.createElement(react_router_1.Route, { path: '/timeline/:challenge', component: Timeline_1.default }),
    React.createElement(react_router_1.Route, { path: '/organizers/:challenge', component: Organizers_1.default }),
    React.createElement(react_router_1.Route, { path: '/quicklinks/:challenge', component: Links_1.default }),
    React.createElement(react_router_1.Route, { path: '/dnsmos/:challenge', component: DnsMOS_1.default }),
    React.createElement(react_router_1.Route, { path: '/finalresults/:challenge', component: FinalResults_1.default }),
    React.createElement(react_router_1.Route, { path: '/phase1results/:challenge', component: Phase1Results_1.default }),
    React.createElement(react_router_1.Route, { path: '/phase2results/:challenge', component: Phase2Results_1.default }),
    React.createElement(react_router_1.Route, { path: '/fetch-data/:startDateIndex?', component: FetchData_1.default }))); });
//# sourceMappingURL=App.js.map